import React, { useContext } from 'react'
import { Modal, Form, Input, Button } from 'antd'
import { AppContext } from 'AppContext'
import { canUserEdit, canUserAdd, canUserSave } from 'utils/User'

const CollectionCreateForm = ({
  visible,
  onCreate,
  onUpdate,
  onCancel,
  isEdit,
  category = {},
}) => {
  const { state: { currentUser, userPermissions, isClient } = {} } = useContext(AppContext) || {}
  const hasEdit = canUserEdit(userPermissions || currentUser, isClient)
  const hasAdd = canUserAdd(userPermissions || currentUser, isClient)
  const hasSave = canUserSave(userPermissions || currentUser, isClient)
  const canSubmit = isEdit ? (hasEdit && hasSave) : (hasAdd && hasSave)

  const [form] = Form.useForm()

  function resetForm() {
    form.resetFields()
  }

  return (
    <Modal
      maskClosable={false}
      visible={visible}
      title={isEdit ? 'Edit Category' : 'Add New Category'}
      okText={isEdit ? 'Update Category' : 'Add Category'}
      okButtonProps={{ disabled: !canSubmit }}
      cancelText='Cancel'
      onCancel={() => {
        resetForm()
        onCancel()
      }}
      onOk={() => {
        if (!canSubmit) return
        form
          .validateFields()
          .then((values) => {
            const data = {
              ...values,
            }
            if (isEdit) {
              onUpdate(data, resetForm)
            } else {
              onCreate(data, resetForm)
            }
          })
          .catch((info) => console.log('Validate Failed:', info))
      }}
    >
      <Form
        form={form}
        layout='vertical'
        name='form_in_modal'
        initialValues={{
          ...category,
        }}
      >
        <Form.Item
          name='category'
          label='Category'
          rules={[
            {
              required: true,
              message: 'Category is require',
              whitespace: true,
            },
          ]}
          hasFeedback
        >
          <Input />
        </Form.Item>
        <div className='footer-btn-div'>
          <Button
            className='footer-cancel-btn'
            onClick={() => {
              resetForm()
              onCancel()
            }}
          >
            Cancel
          </Button>
          <Button
            className='footer-submit-btn'
            disabled={!canSubmit}
            onClick={() => {
              if (!canSubmit) return
              form
                .validateFields()
                .then((values) => {
                  const data = {
                    ...values,
                  }
                  if (isEdit) {
                    onUpdate(data, resetForm)
                  } else {
                    onCreate(data, resetForm)
                  }
                })
                .catch((info) => console.log('Validate Failed:', info))
            }}
            type='primary'
          >
            {isEdit ? 'Update Category' : 'Add Category'}
          </Button>
        </div>
      </Form>
    </Modal>
  )
}

const CreateCategoryModal = (props) => {
  return (
    <div>
      <CollectionCreateForm {...props} />
    </div>
  )
}

export default CreateCategoryModal
